import { createContext } from 'react';
export const defaultPopoverContext = {
  use: 'default'
};
export const PopoverContext = /*#__PURE__*/createContext(defaultPopoverContext);
export const {
  Consumer,
  Provider
} = PopoverContext;